module.exports = __webpack_public_path__ + "img/Bärenjagt.12925acc.svg";